export const initialState = {
  ApplicationList: [],
  ApplicationPage: {}
};
